import { CAMPAIGN_TYPE } from "../BulkCampaigns/BulkCampaignCreate";

export function getFollowUpType(followUp) {
  const { followUpDelay, followUpMessage, whatsAppFollowUp } = followUp;

  const { templateName, language } = whatsAppFollowUp;

  const isFollowUpDelay = Boolean(followUpDelay);
  const isFollowUpMessage = Boolean(followUpMessage);
  const isWhatsAppFollowUp = Boolean(templateName) && Boolean(language);

  if (isFollowUpDelay && !isFollowUpMessage && !isWhatsAppFollowUp) {
    return CAMPAIGN_TYPE.CALL;
  }

  if (isFollowUpDelay && isFollowUpMessage && !isWhatsAppFollowUp) {
    return CAMPAIGN_TYPE.SMS;
  }

  if (isFollowUpDelay && !isFollowUpMessage && isWhatsAppFollowUp) {
    return CAMPAIGN_TYPE.WHATSAPP;
  }
}
